import {
  DEFAULT_PRODUCT_PENDING_POLL_MS,
  MAX_PRODUCT_PENDING_POLLS,
  productPendingPollDelay,
} from "./productPendingPoll";

// Plan for the logo LIST's re-read of a HELD price ladder (flag
// REACT_APP_LOGO_PRICE_HELD_ENABLED; the API flag PriceCurrencyListHoldEnabled,
// js-kitmaker-api#1295, answers a new logo's list row with priceHeld: true +
// product.prices: [] while its serial price channel is still empty). Pure
// module - no flag reads, no timers - so the hook and the tests share one
// table.
//
// The hold ends when the API's worker fills the channel: within seconds when
// the prime on product refresh runs (PriceSerialPrimeOnProductRefreshEnabled),
// otherwise at the next 5-minute drain of its price queue. The pending poll's
// shared plan (3 / 8 / 15 s = reads at 3 / 11 / 26 s after the page settled)
// catches the first case; owner decision 1b (31/10) adds TWO slow ticks that
// reach the second: 34 s and 270 s after the previous tick = reads at 60 s
// and 330 s after settle, so one full drain is always inside the window.
// Only a page with at least one HELD row gets them (the pending rows' own
// budget stays 3 - useLogoListPendingPoll decides per page); at most +2
// GetAllLogos per view, 0 calls per row.
export const PRICE_HELD_SLOW_POLL_MS: readonly number[] = [34_000, 270_000];

// Reads per list view with a held row: the shared 3 + the 2 slow ticks.
export const MAX_PRICE_HELD_POLLS =
  MAX_PRODUCT_PENDING_POLLS + PRICE_HELD_SLOW_POLL_MS.length;

// Owner decision 1c (31/10): a return to the tab (document visibilitychange
// -> visible, window focus) restarts the budget once while a held row is
// still on the page - but never twice within this window, measured from when
// the running budget began: the two events of one tab switch count once, tab
// flipping cannot spam the API, and a return during the fast plan changes
// nothing.
export const PRICE_HELD_FOCUS_RESTART_DEBOUNCE_MS = 30_000;

// The delay before read number `attempt` (0-based) for a page with a held
// row: the shared plan while it lasts, then the slow ticks, then undefined
// (budget spent). A custom shared schedule (REACT_APP_PRODUCT_PENDING_POLL_MS,
// capped to 3 entries by its parser) is honoured: the slow ticks follow its
// last entry. Pure.
export function priceHeldPollDelay(
  attempt: number,
  delays: readonly number[] = DEFAULT_PRODUCT_PENDING_POLL_MS,
  slowDelays: readonly number[] = PRICE_HELD_SLOW_POLL_MS
): number | undefined {
  if (!Number.isInteger(attempt) || attempt < 0) return undefined;
  const shared = productPendingPollDelay(attempt, delays);
  if (shared !== undefined) return shared;
  const sharedCount = Math.min(delays.length, MAX_PRODUCT_PENDING_POLLS);
  if (attempt < sharedCount) return undefined;
  return slowDelays[attempt - sharedCount];
}
